import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const FamilySchema = withDefaults({
  type: 'family',
  objectExtensions: ['family'],
  fields: [
    {
      kind: 'attribute',
      name: 'firstName',
    },
    {
      kind: 'attribute',
      name: 'lastName',
    },
    {
      kind: 'attribute',
      name: 'familyStatusType',
    },
    {
      kind: 'attribute',
      name: 'familyRelationshipTypeId',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'familyInvites',
      type: 'family-invite',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default FamilySchema;
